const CHECKBOX = 'checkbox';
const SELECT = 'select';
const TEXT_SEARCH = 'text-search';
const SEARCH_TERM = 'search_term';
const SIZE = process.env.BLAZE_PB_SEARCH_FILETER_AGG_SIZE || 500;
const KEYWORD = 'keyword';
const RAW_RESULTS = 'rawResults';
const DEFAULT_OPTION = 'Any';
const DEFAULT_VALUES = ['Any', 'Please Choose...'];
const RANGE = 'range';
const CHECKBOX_SELECT = ['checkbox', 'select'];
const LIMIT_MIN = 5;
const LIMIT_MAX = 1000;
const MORE = 'more';
const LESS = 'less';
const UPDATED_RANGES = 'updated_ranges';
const MIN_VALUE = 'min-value';
const MAX_VALUE = 'max-value';
const TABLET_WIDTH = 768;
const RESET = 'Reset all filters';
const SEARCH = 'Search';
const REFINE = `Refine Search`;
const MOBILE_REFINEMENT_TITLE = 'Search refinement';

const MORE_FILTERS_CLASSES_BASE = 'filter__more-filters';
const MORE_FILTERS_CLASSES = {
  MOBILE_WRAPPER: `${MORE_FILTERS_CLASSES_BASE}-mobile-wrapper`,
  MOBILE_CONTENT: `${MORE_FILTERS_CLASSES_BASE}-mobile-content`,
  MOBILE_TOGGLER: `${MORE_FILTERS_CLASSES_BASE}-mobile-toggler`,
  MOBILE_BUTTONS: `${MORE_FILTERS_CLASSES_BASE}-mobile-buttons`,
  DESKTOP_WRAPPER: `${MORE_FILTERS_CLASSES_BASE}-desktop-wrapper`,
  DESKTOP_CONTENT: `${MORE_FILTERS_CLASSES_BASE}-desktop-content`,
  DESKTOP_TOGGLER: `${MORE_FILTERS_CLASSES_BASE}-desktop-toggler`,
  DESKTOP_BUTTONS: `${MORE_FILTERS_CLASSES_BASE}-desktop-buttons`
};

export {
  CHECKBOX,
  SELECT,
  TEXT_SEARCH,
  SEARCH_TERM,
  SIZE,
  KEYWORD,
  RAW_RESULTS,
  DEFAULT_OPTION,
  DEFAULT_VALUES,
  RANGE,
  CHECKBOX_SELECT,
  LIMIT_MIN,
  LIMIT_MAX,
  MORE,
  LESS,
  UPDATED_RANGES,
  MIN_VALUE,
  MAX_VALUE,
  TABLET_WIDTH,
  RESET,
  SEARCH,
  REFINE,
  MOBILE_REFINEMENT_TITLE,
  MORE_FILTERS_CLASSES
};
